'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CarouselProgress({
  selectedIndex,
  totalSlides,
  className,
}: {
  selectedIndex: number;
  totalSlides: number;
  className?: {
    container?: string;
    activeBar?: string;
  };
}) {
  return (
    <div
      className={cn(
        'flex h-[5px] w-full flex-1 items-center justify-start overflow-hidden rounded-[40px] bg-border',
        className?.container,
      )}
    >
      <div
        className={cn('h-[5px] bg-black transition-all ease-in-out', className?.activeBar)}
        style={{ width: `${((selectedIndex + 1) / (totalSlides || 1)) * 100}%` }}
      />
    </div>
  );
}
